import { Stack } from '@mantine/core';
import { Icon, Text } from '@repo/foundations';
import dayjs from 'dayjs';
import type { AutomationJob } from '../../../api/types/models/automation/automationJob';
import {
	formatShortTimeDifference,
	humanReadableTimeElapsed,
} from '../../../utils/time';
import { AutomationRunStatusBadge } from '../../Automation/AutomationRunStatusBadge';
import { AUTOMATION_JOB_STATUS } from '../../Automation/utils';
import { StaticProperty } from '../../EntityPageLayout/EntityPropertySidebar';

interface AutomationJobDrawerSummaryProps {
	automationJob: AutomationJob;
}

export function AutomationJobDrawerSummary({
	automationJob,
}: AutomationJobDrawerSummaryProps) {
	const startedAt = automationJob.started_at;
	const completedAt = automationJob.success_at || automationJob.error_at;
	let duration = null;
	if (startedAt && completedAt) {
		duration = dayjs(completedAt).diff(dayjs(startedAt), 'seconds');
	}
	const resourcesToReviewCount = automationJob.resources_to_review_count;
	const affectedRecordsCount = automationJob.affected_records_count;

	const resourceCount =
		automationJob.status !== AUTOMATION_JOB_STATUS.COMPLETED
			? resourcesToReviewCount
			: affectedRecordsCount;
	const textColor =
		automationJob.status !== AUTOMATION_JOB_STATUS.COMPLETED
			? 'text/secondary/default'
			: 'text/primary/default';

	return (
		<Stack spacing={'xs'}>
			<StaticProperty
				wideLabel={true}
				label="Started time"
				custom={
					<Text size="sm">{formatShortTimeDifference(startedAt, true)}</Text>
				}
			/>
			<StaticProperty
				wideLabel={true}
				label="Status"
				custom={<AutomationRunStatusBadge status={automationJob.status} />}
			/>
			<StaticProperty
				wideLabel={true}
				label="Initiated by"
				custom={<Text size="sm">System</Text>}
			/>
			<StaticProperty
				wideLabel={true}
				label="Duration"
				custom={
					duration ? (
						<Text size="sm">{humanReadableTimeElapsed(duration)}</Text>
					) : (
						<Icon name="lineDashed" />
					)
				}
			/>
			<StaticProperty
				wideLabel={true}
				label="Resources"
				custom={
					<Text size="sm" color={textColor}>
						{resourceCount}
					</Text>
				}
			/>
		</Stack>
	);
}
